import { render } from "./App.vue?vue&type=template&id=dd58b814"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dd58b814&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__